var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGiftsvgrIcon = function SvgGiftsvgrIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 34 34",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.587 17.416v13.82H5.517v-13.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.345 10.507H2.759v6.91h27.586zM16.552 31.236v-20.73M16.552 10.507h-6.207a3.45 3.45 0 0 1-2.439-1.012 3.46 3.46 0 0 1 0-4.886 3.45 3.45 0 0 1 2.439-1.012c4.827 0 6.207 6.91 6.207 6.91M16.552 10.507h6.207c.914 0 1.791-.364 2.438-1.012a3.46 3.46 0 0 0 0-4.886 3.45 3.45 0 0 0-2.438-1.012c-4.828 0-6.207 6.91-6.207 6.91"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGiftsvgrIcon);
export default ForwardRef;